import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=0d83e5c4&lang=pug&"
import script from "./Error500.vue?vue&type=script&lang=ts&"
export * from "./Error500.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports